module.exports = require("npm:json-schema-ref-parser@3.1.2/lib/index.js");